import {QRCodeSVG} from 'qrcode.react';
//AntDesign Imports
import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import './QrCode.css';

const QrCode = (props) => {
  const {
    value,
    title,
    qrSize,
    bgColor,
    fgColor,
    level,
    imgSrc,
    imgX,
    imgY,
    imgWidth,
    imgHeight,
    imgOpacity,
    isExcavate,
    showActions = false
  } = props;

  const onDownloadBarcodes = () => {
    // Select all barcode wrapper elements
    const elements = document.querySelectorAll(".QrCode-wrapper");
    
    // Convert elements to HTML strings
    const printableContent = Array.from(elements).map((element) => element.outerHTML);

    // Create a hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    // Append iframe to document body
    document.body.appendChild(iframe);
    const doc = iframe.contentDocument || iframe.contentWindow.document;

    // Write printable content to iframe document with enhanced print styling
    doc.open();
    doc.write(`
    <html>
      <head>
      <title>Stack Enable</title>
        <style>
          @media print {
            /* Hide everything by default */
            body {
              margin: 0;
              padding: 0;
            }

            /* Remove header and footer */
            @page {
              margin: 10mm;
              size: auto;
              margin-top: 10mm;
              margin-bottom: 10mm;
              margin-left: 10mm;
              margin-right: 10mm;
            }

            /* Style for barcodes */
            .QrCode-wrapper {
              visibility: visible;
              page-break-inside: avoid;
              display: flex;
              flex-direction: column;
              align-items: center;
              max-width: 90%;
              margin:0 10mm;
            }

            /* Style for QrCode */
            .QrCode{
              margin: 1mm;
              text-align: center;
            }

            .QrCode-value{
             font-size:16px;
             font-family:monospace;
            }

            /* Ensure only page numbers are visible */
            @page {
              @bottom-center {
                content: counter(page);
                font-size: 10pt;
              }
            }
          }

          /* Hide content in normal view */
          body {
            visibility: hidden;
          }
            .download-button{
             visibility: hidden;
            }
        
        </style>
      </head>
      <body>
        ${printableContent.join("")}
      </body>
    </html>
  `);
    doc.close();

    // Wait for iframe to load
    iframe.onload = () => {
      // Trigger print dialog
      iframe.contentWindow.print();
      
      // Remove iframe after printing
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
};


  return (
    <div className="QrCode-wrapper">
    <div className="QrCode">
         <QRCodeSVG
      value={value}
      title={title}
      fontFamily='monospace'
      size={qrSize || 100}
      bgColor={bgColor}
      fgColor={fgColor}
      level={level || "L"}
      imageSettings={{
        src: { imgSrc },
        x: imgX || undefined,
        y: imgY || undefined,
        height: imgHeight,
        width: imgWidth,
        opacity: imgOpacity,
        excavate: isExcavate || false,
      }}
    />
     <h1 className='QrCode-value'>{value}</h1>
      </div>
      {
        showActions && (
          <div className="download-button">
            <Button type="primary" style={{ width: "25px", height: "25px" }} icon={<DownloadOutlined />} size={"medium"} onClick={onDownloadBarcodes} ></Button>
          </div>
        )
      }
    </div>
  );
};

export default QrCode;
